import React from "react";
import { PaymentType } from "univapay-node";

import { Content as SelectorContent } from "../common/FormTokenSelector";

export const Content = (props) => <SelectorContent {...props} paymentType={PaymentType.CARD} />;

export default Content;
